import Api from '@/common/api';
import {
  REFRESH_TOKEN,
  SET_CURRENT_USER_IRS,
  SIGN_OUT_USER,
  VERIFY_TOKEN,
} from '../types/authenticate';

const api = Api.getApi();

export async function getCurrentUser() {
  try {
    const response = await api.request('get', '/user');
    return response && response.data;
  } catch (err) {
    return {};
  }
}

export function requestCurrentUserIRS() {
  return { type: SET_CURRENT_USER_IRS };
}

export const getToken = (params = {}, callback) => ({
  type: VERIFY_TOKEN,
  params,
  callback,
});

export const refreshToken = (params = {}, callback = null) => ({
  type: REFRESH_TOKEN,
  params,
  callback,
});

export const requestSignOut = (callback) => ({
  type: SIGN_OUT_USER,
  callback,
});
